import { useCourseKit } from "@bodemleven/course-kit/react";
import { shellCopy, type ShellCopy } from "./shell.ts";

/** The shell strings in the visitor's current locale (nl or en). */
export const useShellCopy = (): ShellCopy => shellCopy[useCourseKit().locale];
